import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "flex-grow-1" }
const _hoisted_5 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_6 = { class: "d-flex flex-column" }
const _hoisted_7 = { class: "d-flex align-items-center mb-2" }
const _hoisted_8 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_9 = { class: "d-flex my-4" }
const _hoisted_10 = {
  key: 0,
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_new_group_weight_value",
  type: "button",
  class: "btn btn-sm btn-flex btn-primary"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap flex-stack" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-column flex-grow-1 pe-8" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-wrap" })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GroupValuesTable = _resolveComponent("GroupValuesTable")!
  const _component_QualityGroupsCreating = _resolveComponent("QualityGroupsCreating")!
  const _component_QualityGroupsWeight = _resolveComponent("QualityGroupsWeight")!
  const _component_QuestionsCreating = _resolveComponent("QuestionsCreating")!
  const _component_QuestionsEditing = _resolveComponent("QuestionsEditing")!
  const _component_QuestionWeight = _resolveComponent("QuestionWeight")!
  const _component_QualityGroupsEditing = _resolveComponent("QualityGroupsEditing")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.can('read', 'ive'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.translate('qualityGroupsPanel')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    (_ctx.can('create', 'ive'))
                      ? (_openBlock(), _createElementBlock("button", _hoisted_10, _toDisplayString(_ctx.translate('updateGroupsWeight')), 1))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_11
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupsValues, (value, key) => {
      return (_openBlock(), _createBlock(_component_GroupValuesTable, {
        key: key,
        value: value,
        onShowCreateQuestionModal: _ctx.showQuestionCreateModal,
        onShowEditModal: _ctx.showGroupEditModal,
        onShowEditQuestionModal: _ctx.showEditQuestionModal,
        onShowEditQuestionWeightModal: _ctx.showEditQuestionWeightModal
      }, null, 8, ["value", "onShowCreateQuestionModal", "onShowEditModal", "onShowEditQuestionModal", "onShowEditQuestionWeightModal"]))
    }), 128)),
    _createVNode(_component_QualityGroupsCreating, { onNewValueCreated: _ctx.refreshValues }, null, 8, ["onNewValueCreated"]),
    _createVNode(_component_QualityGroupsWeight, { onNewValueCreated: _ctx.refreshValues }, null, 8, ["onNewValueCreated"]),
    _createVNode(_component_QuestionsCreating, {
      onNewValueCreated: _ctx.refreshValues,
      "group-id": _ctx.groupId
    }, null, 8, ["onNewValueCreated", "group-id"]),
    _createVNode(_component_QuestionsEditing, {
      "edit-data": _ctx.editData,
      onNewValueCreated: _ctx.refreshValues
    }, null, 8, ["edit-data", "onNewValueCreated"]),
    _createVNode(_component_QuestionWeight, {
      "edit-weight": _ctx.editWeight,
      onNewValueCreated: _ctx.refreshValues
    }, null, 8, ["edit-weight", "onNewValueCreated"]),
    _createVNode(_component_QualityGroupsEditing, {
      "edit-data": _ctx.editData,
      onNewValueCreated: _ctx.refreshValues
    }, null, 8, ["edit-data", "onNewValueCreated"])
  ], 64))
}